"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeeKeepSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class BeeKeepSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.BEE_KEEP);
    }
    onClear() {
    }
    onLocalMessage(message) {
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    update(delta) {
    }
}
exports.BeeKeepSystem = BeeKeepSystem;
//# sourceMappingURL=module.js.map